import request from '../utils/request';
import { ICompetitor, IEvent, IObjectStyle, IOdds, IPrevEvent, IProvider, IWidget, IWidgetMeta, IWidgetProvider, IDeal, IWidgetAvailableMarket } from "../utils/types";
import { ITranslation } from "../utils/translations"

export interface IOutrightOdds {
  odds: IOdds[],
  prevMeetings: IEvent[],
  nextEvent: IEvent|null,
  oddsStatistics: {
    averageOdds: number,
    highestOdds: number,
    lowestOdds: number,
  }
}

export interface IOutrightOddsWidgetResponse extends IWidget {
  translations: ITranslation[],
  widgetStyles: IObjectStyle[],
  widgetMetas: IWidgetMeta[],
  widgetProviders: IWidgetProvider[],
  marketTypeId: number,
  availableMarkets : IWidgetAvailableMarket[]
}

export interface ICompetitorOdds {
  competitor: ICompetitor,
  outRightOddsData: IOutrightOdds,
}

export interface IOutrightOddsResponse {
  success: boolean,
  message?: string,
  widget: IOutrightOddsWidgetResponse,
  competitorOdds: ICompetitorOdds[],
}

export interface IEventDataResponse {
  event: IEvent,
  prevMeetings: IPrevEvent[],
  providerDeals: IDeal[],
  bestOdds: {
    bestProvider: IProvider | null,
    bestOdds: IOdds[],
  }
}

export function fetchWidgetData(widgetID: number) {
  return request(`/api/outright-odds/widget-data/${widgetID}`) as unknown as Promise<IOutrightOddsWidgetResponse>;
}

export function fetchTableData(query: object) {
  return request('/api/outright-odds/table-data', query) as unknown as Promise<IOutrightOddsResponse>;
}

export function fetchEventData(query: object) {
  return request('/api/outright-odds/event-data', query) as unknown as Promise<IEventDataResponse>;
}
